import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';

export class Step136784Meta extends BaseModel {
  /**
   * @var {boolean}
   */
  wasDeceasedMarriedBefore;

  /**
   * @var {boolean}
   */
  wasDeceasedInConjugalRelationship;

  /**
   * @param {number}
   */
  formerSpouseCount;

  constructor(model = {}) {
    super();
    this.wasDeceasedMarriedBefore = model.wasDeceasedMarriedBefore;
    this.wasDeceasedInConjugalRelationship = model.wasDeceasedInConjugalRelationship;
    this.formerSpouseCount = model.formerSpouseCount ?? 0;
  }
}
